import React from "react";
import classNames from "classnames";
import { Icomoon, CircleIcon } from "../../brand";
import "./IconListItem.scss";

interface Props {
  icomoon: Icomoon;
  className?: string;
}

/**
 * A list item component with configurable icon as the bullet point.
 * 
 * @status development
 */
export const IconListItem: React.FC<Props> = ({ icomoon, className, children }) => {
  return (
    <div className={classNames("icon-list-item", "columns", "is-mobile", className)}>
      <div className="column is-narrow">
        <CircleIcon
          className="icon-list-item__icon"
          icon={icomoon}
        />
      </div>
      <div className="column">
        {children}
      </div>
    </div>
  );
}
